// sass native
@use 'sass:map';
@use 'sass:color';

// csc-button
@use '~@cewe-designsystem-stylecomponents/button' as button;

$button-primary-color: #c30c15 !default;

// csc-mixins
@import '~@cewe-designsystem-stylecomponents/mixins/colors';

// csc-input
$csc-input-padding: 0.5rem !default;
$csc-input-filled-color: var(--cwc-newsletter-signup-input-color, #4c4c4c82) !default;
$csc-input-filled-color-bg: var(--cwc-newsletter-signup-input-background-color, #f0eeedb3) !default;
$csc-input-color-error-bg: #fbf0c1 !default;
$csc-input-color-error: #c79511 !default;
@import '~@cewe-designsystem-stylecomponents/input';

// csc-loading-animation
$csc-loading-animation-color: var(--cwc-newsletter-signup-loading-animation-background-color, #ddd5cd) !default;
@import '~@cewe-designsystem-stylecomponents/loading-animation';

// cwc-newsletter-signup
$cwc-newsletter-signup-input-width: var(--cwc-newsletter-signup-input-width, 344px) !default;
$cwc-newsletter-signup-input-padding: var(--cwc-newsletter-signup-input-padding, 1rem) !default;
$cwc-newsletter-signup-input-border-radius: var(--cwc-newsletter-signup-input-border-radius, 5px) !default;
$cwc-newsletter-signup-input-filled-color-bg: var(--cwc-newsletter-signup-input-background-color, #eeeced) !default;

/* cwc-newsletter-signup */
:host {
  /**
   * @prop --cwc-newsletter-signup-loading-mobile-breakpoint - Breakpoint to desktop and mobile styling
   * @prop --cwc-newsletter-signup-font-family - Font used in this component, defaults to global base font family
   */

  --cwc-newsletter-signup-loading-mobile-breakpoint: 1024px;
  display: flex;

  font-family: var(--cwc-newsletter-signup-font-family, var(--base-font-family));

  cwc-newsletter-signup-headline {
    display: block;
  }

  cwc-newsletter-signup-subheadline {
    display: block;
    margin-bottom: 1rem;
  }

  cwc-newsletter-signup-text {
    display: block;
    max-width: 500px;
    margin: 0 auto;
    font-size: 0.8em;
    text-align: left;
  }

  // container for displaying subtext and button side-by-side
  cwc-newsletter-signup-info {
    display: flex;
    align-items: center;
    min-width: calc($cwc-newsletter-signup-input-width + $cwc-newsletter-signup-input-padding);
    margin-top: 2rem;

    // subtext should be left-aligned in initial state only
    ::slotted([slot='initial-subtext']) {
      max-width: 200px;
      padding-right: 1rem;
      font-size: 10px;
      text-align: left;
    }

    p,
    button {
      flex: auto;
    }
  }

  .csc-button {
    @include button.button;
  }

  .csc-button-basic {
    @include button.button--basic;
  }

  .csc-button-strong--on-light {
    @include button.button-strong--on-light;

    &[disabled] {
      @include button.button-strong--on-light--disabled;
    }
  }

  .csc-button-lite--on-light {
    @include button.button-lite--on-light;

    &[disabled] {
      @include button.button-lite--on-light--disabled;
    }
  }

  // @TODO: replace with input field with floating label, when stylecomponent will exist in the future
  input {
    @extend %csc-input;

    width: $cwc-newsletter-signup-input-width;
    margin-top: 3rem;
    padding: $cwc-newsletter-signup-input-padding;
    border-radius: $cwc-newsletter-signup-input-border-radius $cwc-newsletter-signup-input-border-radius 0 0;

    background-color: $csc-input-filled-color-bg;
    color: $csc-input-filled-color;
    font-family: var(--cwc-newsletter-signup-font-family, var(--base-font-family));

    &:invalid {
      border-bottom: 2px solid $csc-input-color-error;
      background-color: $csc-input-color-error-bg;
      color: color.adjust($csc-input-color-error, $alpha: -0.51);
    }
  }

  form {
    display: flex;
    position: relative;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: space-around;
    max-width: calc($cwc-newsletter-signup-input-width);
    margin-right: auto;
    margin-left: auto;

    strong {
      position: absolute;
      top: 108px;
      width: 100%;
      color: $csc-input-color-error;
      font-size: 60%;
      text-align: left;
    }
  }

  // for illustration usage in newsletter-section (deprecated module!)
  ::slotted([slot^='illustration-']) {
    --margin: 1.5rem;
    display: none;
    align-self: center;
    width: calc(100% - 2 * var(--margin));
    max-width: 290px;
    margin: var(--margin);
  }

  cwc-newsletter-signup {
    &-container {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    &-main {
      flex: 1 1 40%;
      margin: 0 2rem;
      text-align: center;
    }
  }

  csc-loading-animation[type='small'] {
    @extend %csc-loading-animation-small;

    margin-top: 0.5rem;
    padding: 1rem 0;
  }
}

:host([signup-state='initial']) {
  ::slotted([slot='illustration-before']) {
    display: block;
  }
}

/**
 * successful host styles
 */
:host([signup-state='successful']) {
  cwc-newsletter-signup {
    &-container {
      flex-direction: column-reverse;
    }
  }

  ::slotted([slot='illustration-after']) {
    display: block;
  }
}

/**
 * failed host styles
 */
:host([signup-state='failed']) {
  cwc-newsletter-signup {
    &-main {
      cwc-newsletter-signup-headline {
        margin-top: 1.5rem;
      }
    }
  }

  button {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}

:host([usage='embedded']) {
  cwc-newsletter-signup-headline {
    margin-top: 0;
    font-size: 1rem;
    line-height: 1.4;
  }

  form {
    width: auto;
    max-width: 100%;
    margin: 0;
  }
}

// text in initial- or load-state should be left-aligned when in embedded mode
:host([usage='embedded'][signup-state='initial']),
:host([usage='embedded'][signup-state='load']) {
  cwc-newsletter-signup-main {
    text-align: left;
  }
}

:host([usage='embedded'][signup-state='failed']) {
  cwc-newsletter-signup-headline {
    margin-top: 0;
  }
}

// desktop
@media (min-width: var(--cwc-newsletter-signup-loading-mobile-breakpoint)) {
  :host {
    cwc-newsletter-signup {
      &-container {
        flex-direction: row;
      }

      &-main cwc-newsletter-signup-headline {
        margin-top: 1.5rem;
      }

      &-main {
        margin: 0;
      }

      &-text {
        max-width: none;
        margin: 0;
      }
    }

    p,
    form {
      margin: 0;
    }

    form {
      max-width: none;
    }
  }

  :host([signup-state='successful']) {
    cwc-newsletter-signup {
      &-container {
        flex-direction: row;
      }
    }
  }
}
